import React from 'react';

export default () => (
  <div className='NotFound'>
    <div>
      <h1>401</h1>
      <div className='content'>
        <h2>No permissions.</h2>
      </div>
      <p>
        {/* <a href={ROUTE_PATH.MAIN_PAGE}>Go home</a> */}
      </p>
    </div>
  </div>
);
